module.exports = __webpack_public_path__ + "img/ui-layout.60f87fe9.svg";